import { Component, OnInit } from '@angular/core';
import { TokenService } from '../../../core/tokenManagement/token.service';

@Component({
  selector: 'app-dashboard-home',
  templateUrl: './dashboard-home.component.html',
  styleUrls: ['./dashboard-home.component.css']
})
export class DashboardHomeComponent implements OnInit {
  userLocalDetails;
  country = '';

  constructor( private tokenservice: TokenService,
    ) { }

  ngOnInit() {
    this.userLocalDetails = this.tokenservice.getUserCred();
    this.country = this.userLocalDetails['country'];    
  }

}
